<template>
  <div class="flex items-center">
    <feather-icon icon="FileIcon" :title="params.data.original_name_file" svgClasses="h-7 w-7" @click.stop="downloadContractFile(params.data.id_added_service, params.data.original_name_file)" v-if="params.data.original_name_file"/>
  </div>
</template>

<script>
import axios from '@/axios.js'
export default {
  name: 'CellRendererLink',
  methods: {
    downloadContractFile (id_added_service, original_name_file) {
      axios({
        method: 'get',
        url: `${axios.defaults.baseURL}added-service/${id_added_service}/download-contract`,
        responseType:'blob'})
        .then(response => {
          this.forceFileDownload(response, original_name_file)
        })
        .catch((err) => {
          console.log(err)
          this.$vs.notify({
            title: 'Error',
            color: 'warning',
            iconPack: 'feather',
            icon:'icon-x-circle',
            time: 4000
          })

        })
    },
    forceFileDownload (response, original_name_file) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      // const contentDisposition = response.headers['content-disposition']
      const contentType = response.headers['content-type']
      let fileName = original_name_file
      if (contentType === 'image/jpeg') {
        // const fileNameMatch = contentDisposition.match(/(?<=filename=).*/);
        // fileName = fileNameMatch[0];
        fileName = `${original_name_file}`
      } if (contentType === 'image/png') {
        // const fileNameMatch = contentDisposition.match(/(?<=filename=).*/);
        // fileName = fileNameMatch[0];
        fileName = `${original_name_file}`
      } if (contentType === 'application/pdf') { 
        // const fileNameMatch = contentDisposition.match(/"([^"]*)"/);
        // fileName = fileNameMatch[1];
        fileName = `${original_name_file}`
      }
      link.setAttribute('download', fileName) //or any other extension
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
